export enum BroadcastMessageItemStatus {
  Acked = 'ACKED',
  New = 'NEW'
}
